import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;

export const HeaderConfiguration = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 3px;

  span {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: center;

    color: #ffffff;
  }
`;

export const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 114px;
  box-sizing: border-box;
  padding: 10px;

  span {
    margin-left: 16px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.05em;

    color: #4d4d4d;
  }
`;

export const Avatar = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 96px;
  height: 96px;
  box-sizing: border-box;
  border-radius: 50%;
  background-color: #c4c4c4;
  margin-top: 10px;

  img {
    position: absolute;
    width: 96px;
    height: 96px;
  }

  :hover {
    span {
      position: absolute;
      bottom: 0;
      color: #000;
    }
    background-color: #000;
    opacity: 0.5;
    cursor: pointer;
  }
`;

export const Form = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  padding: 10px;

  button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    background: linear-gradient(0deg, #5abde7, #5abde7), #a7a7a7;
    border-radius: 5px;
    color: #ffffff;
    border: none;
    cursor: pointer;

    span {
      font-family: "Poppins" !important;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      margin-left: 20px;
    }
  }
`;

export const InputGroup = styled.div`
  display: flex;
  width: 100%;
  height: 60px;
  flex-direction: row;
`;

export const InputContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 10px;

  label {
    font-family: "Poppins" !important;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #4d4d4d;
  }

  input {
    width: 100%;
    height: 30px;
    background: #ffffff;
    border: 1px solid #f3f3f3;
    border-radius: 5px;
  }

  div {
    display: flex;
    width: 100%;
    align-items: start;
    flex-direction: column;
  }

  div {
    margin-left: 10px;
  }
`;
